// The module's own line art, inline so the board carries no network request and
// no build step of its own.
//
// Every path is stroked in `currentColor`: the colour is decided by the CSS that
// places the icon, which is how a rebrand reaches these without editing them
// (ADR-0014).

import type { MilestoneId } from "./milestones";

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

function Link() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke}>
      <path d="M10.5 13.5a4 4 0 0 0 5.7 0l2.3-2.3a4 4 0 0 0-5.7-5.7l-1.3 1.3" />
      <path d="M13.5 10.5a4 4 0 0 0-5.7 0l-2.3 2.3a4 4 0 0 0 5.7 5.7l1.3-1.3" />
    </svg>
  );
}

function Compose() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke}>
      <path d="M4.5 6.5h9M4.5 10.5h9M4.5 14.5h5" />
      <path d="m14.8 17.4 4.9-4.9a1.6 1.6 0 0 0-2.2-2.2l-4.9 4.9-.6 2.8 2.8-.6Z" />
    </svg>
  );
}

function Clock() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke}>
      <path d="M4.5 6.5h11v12h-11z" />
      <path d="M4.5 9.5h11M7.5 4.5v3M12.5 4.5v3" />
      <circle cx="17.5" cy="16" r="4" />
      <path d="M17.5 14.2V16l1.3 1" />
    </svg>
  );
}

function Upload() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke}>
      <path d="M6.5 16.5a3.5 3.5 0 0 1-.3-7 5 5 0 0 1 9.6-1.2 3.9 3.9 0 0 1 1.7 7.6" />
      <path d="M12 19.5v-7M9.4 14.6 12 12l2.6 2.6" />
    </svg>
  );
}

export const MILESTONE_ICON: Record<MilestoneId, () => JSX.Element> = {
  "connect": Link,
  "first-post": Compose,
  "schedule": Clock,
  "library": Upload,
};

/** The coach. A face, so the line beside it reads as advice rather than chrome. */
export function CoachMark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className="eng-coach-mark">
      <rect x="5.5" y="9.5" width="21" height="16" rx="5.5"
            fill="currentColor" opacity=".14" />
      <rect x="5.5" y="9.5" width="21" height="16" rx="5.5" {...stroke} />
      <path d="M16 6.2v3.3M13 6.2h6" {...stroke} />
      <circle cx="12" cy="16.6" r="1.9" fill="currentColor" />
      <circle cx="20" cy="16.6" r="1.9" fill="currentColor" />
      <path d="M13.2 21.4h5.6" {...stroke} />
      <path d="M2.8 15.5v4M29.2 15.5v4" {...stroke} />
    </svg>
  );
}

/** The setup badge used in the toolbar and minimized launcher. */
export function SparkleMark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className="eng-sparkle-mark">
      <path
        d="M15.8 4.8c1.2 5.2 3.7 7.7 8.8 8.8-5.1 1.2-7.6 3.7-8.8 8.8-1.2-5.1-3.7-7.6-8.8-8.8 5.1-1.1 7.6-3.6 8.8-8.8Z"
        fill="currentColor"
      />
      <path
        d="M25.1 3.8c.6 2.4 1.8 3.7 4.2 4.2-2.4.6-3.6 1.8-4.2 4.2-.6-2.4-1.8-3.6-4.2-4.2 2.4-.5 3.6-1.8 4.2-4.2ZM7.2 19.6c.5 2.2 1.6 3.3 3.8 3.8-2.2.5-3.3 1.6-3.8 3.8-.5-2.2-1.6-3.3-3.8-3.8 2.2-.5 3.3-1.6 3.8-3.8Z"
        fill="currentColor"
        opacity=".72"
      />
    </svg>
  );
}

export function Tick() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} strokeWidth={2.4}>
      <path d="m6.5 12.4 3.6 3.6 7.4-8" />
    </svg>
  );
}
